/**
 * Verti DEU PL API
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * (german: Rechtsform)   (bipro-datentypen::Rechtsform)
 */
export const LegalStructure = {
  Gmbh: 'GMBH',
  Ag: 'AG',
  Ug: 'UG',
  Gbr: 'GBR',
  Ohg: 'OHG',
  Kg: 'KG',
  GmbhCoKg: 'GMBH_CO_KG',
  Eu: 'EU',
  Verein: 'VEREIN',
} as const;
export type LegalStructure = (typeof LegalStructure)[keyof typeof LegalStructure];
